import React from "react";
import "../Contact.css";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import { NavLink } from "react-router-dom";

import {
    FiHome,
    FiChevronRight,
    FiMail,
} from "react-icons/fi";

const Contact = () => {

    return (

        <>

            <Header />

            {/* =====================================================
                            HERO SECTION
            ===================================================== */}

            <section className="contact-hero">

                <div className="contact-overlay"></div>

                <div className="container">

                    <div className="contact-hero-content">

                        <span className="contact-tag">
                            Let's Connect
                        </span>

                        <h1>

                            Let's Build Your
                            <span> Digital Future </span>
                            Together

                        </h1>

                        <p>

                            Whether you're planning an e-commerce platform,
                            business website, mobile application, or custom
                            software solution, our team is ready to help bring
                            your ideas to life. Reach out today and let's
                            discuss how Kishancart Digital (OPC) Private
                            Limited can support your business growth with
                            innovative technology solutions.

                        </p>

                        {/* <div className="contact-hero-buttons">

                            <NavLink
                                to="/services"
                                className="primary-btn"
                            >
                                Explore Services
                            </NavLink>

                            <NavLink
                                to="/company/about-us"
                                className="secondary-btn"
                            >
                                Learn More
                            </NavLink>

                        </div> */}

                    </div>

                </div>

            </section>

            {/* =====================================================
                            BREADCRUMB
            ===================================================== */}

            <section className="contact-breadcrumb">

                <div className="container">

                    <div className="breadcrumb">

                        <NavLink to="/">
                            <FiHome />
                            Home
                        </NavLink>

                        <FiChevronRight />

                        <span className="active">

                            <FiMail />

                            Contact

                        </span>

                    </div>

                </div>

            </section>

            {/* =====================================================
                    NEXT PART STARTS HERE

                Contact Information
                +
                Contact Form

            ===================================================== */}
            {/* =====================================================
                        CONTACT INFORMATION + FORM
            ===================================================== */}

            <section className="contact-section">

                <div className="container">

                    <div className="contact-grid">

                        {/* ================= LEFT SIDE ================= */}

                        <div className="contact-info">

                            <span className="section-tag">
                                Get In Touch
                            </span>

                            <h2>
                                We'd Love to Hear From You
                            </h2>

                            <p>
                                Whether you're launching a new business,
                                expanding your online presence, or looking for
                                custom software solutions, our team is ready to
                                help. Contact us today to discuss your project
                                requirements.
                            </p>

                            {/* <div className="info-card">

                                <h3>🏢 Company Name</h3>

                                <p>
                                    Kishancart Digital (OPC) Private Limited
                                </p>

                            </div> */}

                            <div className="info-card">

                                <h3>📍Office Address</h3>

                                <p>
                                    <a href="https://www.google.com/maps/search/?api=1&query=603+A6,+MD+Complex,+Lalganesh+Lokhra+Road,+Odalbakra,+Kamrup,+GMC,+Assam+781034"
                                        target="_blank"
                                        rel="noopener noreferrer">
                                        603 A6, Md Complex, Lalganesh Lokhra Road
                                        <br />
                                        Odalbakra, Kamrup, Gmc, Assam
                                        <br />
                                        India - 781034
                                    </a>
                                </p>

                            </div>

                            <div className="info-card">

                                <h3>📧 Email Address</h3>

                                <p>
                                    <a href="mailto:contact@opckishancart-digital.in">
                                        contact@opckishancart-digital.in
                                    </a>
                                </p>

                            </div>

                            <div className="info-card">

                                <h3>📞 Phone Number</h3>

                                <p>
                                    <a href="tel:+913617701489">
                                        +913617701489
                                    </a>
                                </p>

                            </div>

                            {/* <div className="info-card">

                                <h3>🕒 Business Hours</h3>

                                <p>
                                    Monday – Friday
                                    <br />
                                    9:30 AM – 6:30 PM


                                </p>

                            </div> */}

                        </div>

                        {/* ================= RIGHT SIDE ================= */}

                        <div className="contact-form-wrapper">

                            <div className="contact-form">

                                <span className="section-tag">
                                    Send Inquiry
                                </span>

                                <h2>Request a Free Consultation</h2>

                                <form>

                                    <div className="form-row">

                                        <div className="form-group">

                                            <label>
                                                Full Name
                                            </label>

                                            <input
                                                type="text"
                                                placeholder="Enter your full name"
                                            />

                                        </div>

                                        <div className="form-group">

                                            <label>
                                                Email Address
                                            </label>

                                            <input
                                                type="email"
                                                placeholder="Enter your email"
                                            />

                                        </div>

                                    </div>

                                    <div className="form-row">

                                        <div className="form-group">

                                            <label>
                                                Phone Number
                                            </label>

                                            <input
                                                type="text"
                                                placeholder="Enter phone number"
                                            />

                                        </div>

                                        <div className="form-group">

                                            <label>
                                                Company Name
                                            </label>

                                            <input
                                                type="text"
                                                placeholder="Your company"
                                            />

                                        </div>

                                    </div>

                                    <div className="form-group">

                                        <label>
                                            Select Service
                                        </label>

                                        <select>

                                            <option>
                                                Select a Service
                                            </option>

                                            <option>
                                                E-Commerce
                                            </option>

                                            <option>
                                                General Enquiry
                                            </option>

                                            <option>
                                                Other
                                            </option>

                                        </select>

                                    </div>

                                    <div className="form-group">

                                        <label>
                                            Enquiry Details
                                        </label>

                                        <textarea
                                            rows="6"
                                            placeholder="Tell us about your enquiry..."
                                        ></textarea>

                                    </div>

                                    <button
                                        type="submit"
                                        className="submit-btn"
                                    >
                                        Send Inquiry
                                    </button>

                                </form>

                            </div>

                        </div>

                    </div>

                </div>

            </section>

            {/* =====================================================
                    NEXT PART STARTS HERE

                Why Contact Us
                +
                Business Information
                +
                Google Map

            ===================================================== */}

            {/* =====================================================
                        WHY CONTACT US
            ===================================================== */}

            <section className="why-contact">

                <div className="container">

                    <div className="section-heading">

                        <span className="section-tag">
                            Why Choose Us
                        </span>

                        <h2>
                            Why Businesses Choose
                            <span> Kishancart Digital</span>
                        </h2>

                        <p>
                            We believe every business deserves reliable,
                            scalable, and innovative technology solutions.
                            Our experienced team works closely with clients
                            to deliver secure, high-performance digital
                            products that support long-term business growth.
                        </p>

                    </div>

                    <div className="why-grid">

                        <div className="why-card">

                            <h3>💡 Free Consultation</h3>

                            <p>
                                Discuss your project requirements with our
                                experts and receive professional guidance
                                before starting your digital journey.
                            </p>

                        </div>

                        <div className="why-card">

                            <h3>⚡ Fast Response</h3>

                            <p>
                                We respond quickly to every inquiry and
                                ensure smooth communication throughout your
                                project lifecycle.
                            </p>

                        </div>

                        <div className="why-card">

                            <h3>🔒 Secure Solutions</h3>

                            <p>
                                Security and reliability are at the core of
                                every website, application, and software
                                solution we build.
                            </p>

                        </div>

                        <div className="why-card">

                            <h3>🤝 Long-Term Partnership</h3>

                            <p>
                                From development to maintenance and future
                                upgrades, we provide continuous technical
                                support for your business.
                            </p>

                        </div>

                    </div>

                </div>

            </section>

            {/* =====================================================
                        BUSINESS INFORMATION
            ===================================================== */}

            <section className="business-info">

                <div className="container">

                    <div className="section-heading">

                        <span className="section-tag">
                            Company Information
                        </span>

                        <h2>
                            Corporate
                            <span> Details</span>
                        </h2>

                    </div>

                    <div className="business-grid">

                        <div className="business-card">

                            <h3>Company Name</h3>

                            <p>
                                Kishancart Digital (OPC) Private Limited
                            </p>

                        </div>

                        <div className="business-card">

                            <h3>Business Type</h3>

                            <p>
                                E-Commerce, Software Development &
                                IT Consulting
                            </p>

                        </div>

                        <div className="business-card">

                            <h3>Business Hours</h3>

                            <p>
                                Monday – Friday
                                <br />
                                9:30 AM – 6:30 PM
                            </p>

                        </div>

                        <div className="business-card">

                            <h3>Support Availability</h3>

                            <p>
                                Email & Phone Support
                                <br />
                                During Business Hours
                            </p>

                        </div>

                        <div className="business-card">

                            <h3>Response Time</h3>

                            <p>
                                Usually Within
                                <br />
                                24 Business Hours
                            </p>

                        </div>

                        <div className="business-card">

                            <h3>Primary Services</h3>

                            <p>
                                E-Commerce, Retail
                                ERP & Agriculture Digital Solutions
                            </p>

                        </div>

                    </div>

                </div>

            </section>

            {/* =====================================================
                        GOOGLE MAP
            ===================================================== */}

            <section className="contact-map">

                <div className="container">

                    <div className="section-heading">

                        <span className="section-tag">
                            Visit Our Office
                        </span>

                        <h2>
                            Find
                            <span> Our Location</span>
                        </h2>

                        <p>
                            We welcome meetings by appointment. Visit our
                            office to discuss your business requirements and
                            digital transformation goals.
                        </p>

                    </div>

                    <div className="map-wrapper">

                        <iframe
                            title="Kishancart Digital Office"
                            src="https://www.google.com/maps?q=603+A6,+MD+Complex,+Lalganesh+Lokhra+Road,+Odalbakra,+Kamrup,+GMC,+Assam+781034&output=embed"
                            width="100%"
                            height="450"
                            style={{ border: 0 }}
                            allowFullScreen
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>

                    </div>

                </div>

            </section>

            <Footer />

        </>

    );

};

export default Contact;